<template>
  <span
    class="spinner-border"
    :class="[`text-${color}`, `spinner-border-${size}`]"
    role="status"
    aria-hidden="true"
  ></span>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    size: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "",
    },
  },
});
</script>
